import script from "./arrangePiece.vue?vue&type=script&setup=true&lang=ts"
export * from "./arrangePiece.vue?vue&type=script&setup=true&lang=ts"

import "./arrangePiece.vue?vue&type=style&index=0&id=fb02adae&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb02adae"]])

export default __exports__